import * as React from "react";
import ReactMarkdown from "react-markdown";

interface MarkdownPageProps {
  content: string;
  title: string;
}

const MarkdownPage: React.FC<MarkdownPageProps> = ({ content, title }) => {
  React.useEffect(() => {
    document.title = title;
  }, [title]);

  return (
    <div className="min-h-screen bg-gray-50">
      <div className="max-w-4xl mx-auto px-4 py-12">
        <div className="bg-white rounded-lg shadow-lg p-8">
          <ReactMarkdown className="prose prose-purple max-w-none">
            {content}
          </ReactMarkdown>
        </div>
      </div>
    </div>
  );
};

export default MarkdownPage;
